<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="4">
						<v-text-field solo flat outlined dense v-model="tableProps.search" label="Buscar..." clearable append-icon="mdi-magnify" hide-details></v-text-field>
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="12" md="2"  class='flexbox-right' v-permission="'quotes.create'">
						<v-btn class='btn-yellow' elevation="0" block :to="{ name: 'CotizacionesRegistro' }" tile>
                            Nueva cotización
                            <v-icon
                                class="ml-2"
                                color=""
                            >
                                mdi-plus
                            </v-icon>    
                        </v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<datatable :props="tableProps" @method_handler="method_handler"></datatable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <modal :props="modalProps" @modalResponse="method_handler"></modal>

	</div>
</template>

<script>
export default {
	data(){
		return {
            actions: [
                {
                    name: 'Detalle',
                    icon: {
                        color: 'secondary',
                        icon: 'mdi-information'
                    },
                    disabled: false,
                    type: 'redirect',   //  method, external, redirect
                    action: '',
                    permissions: 'quotes.show'
                },
                {
                    name: 'Editar',
                    icon: {
                        color: 'secondary',
                        icon: 'mdi-pencil'
                    },
                    disabled: false,
                    type: 'redirect',   //  method, external, redirect
                    action: '',
                    permissions: 'quotes.update'
                },
                {
                    name: 'Borrar',
                    icon: {
                        color: 'secondary',
                        icon: 'mdi-delete'
                    },
                    disabled: false,
                    type: 'method',   //  method, external, redirect
                    action: 'removeRecord',
                    permissions: 'quotes.delete'
                },
                {
                    name: 'Copiar',
                    icon: {
                        color: 'secondary',
                        icon: 'mdi-content-copy'
                    },
                    disabled: false,
                    type: 'redirect',   //  method, external, redirect
                    action: '',
                    permissions: 'quotes.create'
                },
                {
                    name: 'Imprimir',
                    icon: {
                        color: 'secondary',
                        icon: 'mdi-printer'
                    },
                    disabled: false,
                    type: 'external',   //  method, external, redirect
                    action: '',
                    permissions: 'quotes.show'
                },
                {
                    name: 'Orden de trabajo',
                    icon: {
                        color: 'secondary',
                        icon: 'mdi-file-document'
                    },
                    disabled: false,
                    type: 'redirect',   //  method, external, redirect
                    action: '',
                    permissions: 'saleOrders.create'
                }
			],
			tableProps: {
				headers: [
					{
						text: 'Folio',
						align: 'left',
						value: 'sku',
						class: 'primary--text text-uppercase'
					},
					{
						text: 'Fecha',
						align: 'left',
						value: 'date',
						class: 'primary--text text-uppercase'
					},
					{
						text: 'Vendedor',
						align: 'left',
						value: 'seller',
						class: 'primary--text text-uppercase'
					},
					{
						text: 'Cliente',
						align: 'left',
						value: 'client',
						class: 'primary--text text-uppercase'
					},
					{
						text: 'Obra',
						align: 'left',
						value: 'building',
						class: 'primary--text text-uppercase'
					},
					{
						text: 'Total',
						align: 'left',
						value: 'total',
						class: 'primary--text text-uppercase'
					},
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						class: 'primary--text text-uppercase'
					}
				],
				items: [],
				search: ''
			},
			modalProps: {
				visible: false,
				width: '500',
				title: 'Hola',
				text: 'Adiós',
				buttons: [
					{
						text: 'Cancelar',
						color: 'error',
						textColor: 'white',
						btnTypeText: true,
						method: 'cancel',
						parameters: []
					},
					{
						text: 'Aceptar',
						color: 'secondary',
						textColor: 'primary--text mx-1',
						btnTypeText: false,
						method: 'confirm',
						parameters: []
					}
				]
			},
			numberFormat: new Intl.NumberFormat('en-us', {minimumFractionDigits: 2})
		}
	},
	mounted(){
		this.index()
	},
	methods: {
		method_handler(object){
			this[object.method_name](object.parameters)
		},
		index() {
			this.$store.state.overlay = true
			
			this.$http.get(this.$store.state.apiRoute+'/quotes')
			.then((response) => {
				this.tableProps.items = response.data.map((x) => {
					x['actions'] = JSON.parse(JSON.stringify(this.actions))

					x['total'] = '$'+this.numberFormat.format(x.total)

					x.actions[0].action = { name: 'CotizacionesDetalles', params: { id: x.sku } }
					x.actions[1].action = { name: 'CotizacionesEdicion', params: { id: x.sku } }
					x.actions[3].action = { name: 'CotizacionesRegistro', params: { id: x.sku } }
					x.actions[4].action = this.$store.state.apiRoute+'/quotes/'+x.sku+'/pdf'
					x.actions[5].action = { name: 'OrdenesDeVentaRegistro', params: { id: x.sku } }

					x['parameters'] = { id: x.sku }

					return x
				})
			})
			.catch(error => {
				error
			})
			.finally(() => {
				this.$store.state.overlay = false
			})
		},
		removeRecord(parameters){
			// eslint-disable-next-line no-console
			console.log(parameters)
			this.modalProps = {
				visible: true,
				width: '500',
				title: 'Eliminar cotización',
				text: '¿Desea continuar?',
				buttons: [
					{
						text: 'Cancelar',
						color: 'primary',
						textColor: 'white',
						btnTypeText: true,
						method: 'cancel',
						parameters: {}
					},
					{
						text: 'Aceptar',
						color: 'secondary',
						textColor: 'text-base-color mx-1',
						btnTypeText: false,
						method: 'confirm',
						parameters: {
							id: parameters.id
						}
					}
				]
			}
			this.modalProps.visible = true
		},
		confirm(parameters){
			this.$http.delete(this.$store.state.apiRoute+'/quotes/'+parameters.id+'/delete')
			.then(() => {
				this.snackbar = {
					visible: true,
					color: 'green',
					text: 'Se eliminó la cotización',
					timeout: 3000
				}
				this.index()
			}).catch(error => {
                console.error(error);
				this.snackbar = {
					visible: true,
					color: 'red',
					text: 'Error al eliminar. Intenta de nuevo',
					timeout: 3000
				}
			})
			.finally(() => {
				this.modalProps.visible = false
			})
		},
		cancel(){
			this.modalProps.visible = false
		}
	},
}
</script>

<style>

</style>